import React from "react";
import { ArrowDown } from "lucide-react";

const Hero = () => {
  return (
    <section
      id="top"
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6 text-center"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(198,161,91,0.08),transparent_60%)]"
      />
      <p className="animate-fade-up text-xs font-light tracking-luxe uppercase text-gold">
        Est. MMXXIII &nbsp;·&nbsp; Digital Atelier
      </p>
      <h1 className="animate-fade-up mt-8 max-w-4xl font-display text-4xl font-medium leading-tight sm:text-6xl lg:text-7xl">
        Bespoke digital craftsmanship for{" "}
        <em className="italic text-goldLight">discerning</em> ventures.
      </h1>
      <div className="animate-fade-up-slow mx-auto mt-10 h-px w-24 bg-gold/60" />
      <p className="animate-fade-up-slow mt-10 max-w-xl text-base font-light leading-relaxed text-stone">
        Binary Artisan is a private studio crafting singular web experiences —
        engineered without compromise, finished by hand, delivered with
        white-glove care.
      </p>
      <div className="animate-fade-up-slow mt-12 flex w-full max-w-xs flex-col items-stretch gap-4 text-center sm:w-auto sm:max-w-none sm:flex-row">
        <a
          href="#contact"
          className="border border-gold bg-gold px-8 py-3 text-xs font-medium tracking-[0.2em] uppercase text-ink transition-colors duration-300 hover:bg-transparent hover:text-gold"
        >
          Commission a Project
        </a>
        <a
          href="#work"
          className="border border-white/15 px-8 py-3 text-xs font-light tracking-[0.2em] uppercase text-ivory transition-colors duration-300 hover:border-gold hover:text-gold"
        >
          View the Portfolio
        </a>
      </div>
      <a
        href="#work"
        aria-label="Scroll to portfolio"
        className="absolute bottom-10 text-stone transition-colors duration-300 hover:text-gold"
      >
        <ArrowDown size={18} strokeWidth={1.25} />
      </a>
    </section>
  );
};

export default Hero;
